import { Box, Stack, Table, TableBody, TableCell, TableHead, TableRow, useTheme } from '@mui/material';

import classNames from 'classnames/bind';
import styles from '../../Unauthorized/ModalRegisterMasterFollower.module.scss';
import { ListResponse, submitSellPortfoliosStuck } from '@/controllers/gridManager/followerTransManager/followerTransManager';
import TransAuth, { AuthComponentRef } from '@/views/components/componentsUI/TransAuth';
import ButtonElement from '@/views/elements/button/ButtonElement';
import { setStateLoadingAction } from '@/stores/dataManager/Actions/appAction';
import { KeyDataParents, DataOnParents } from './SellStuckStocks';
import ViewNumberFormat from '@/views/elements/Inputs/ViewNumberFormat';
import { useCosInfo, VerifyData } from '@/controllers/gridManager/accountsManager/accountManager';
import { useTranslation } from 'react-i18next';
import { useRef, useState } from 'react';
import { validateCode } from '@/utilities';
import ToastUtil from '@/views/components/Toast/Toast';
import useValidateCode from '@/componentShare/hooks/useValidateCode';
const cx = classNames.bind(styles);

export type PropsStep = {
    close: () => void,
    back: () => void,
    next: () => void,
    handleSaveDataOnParents: (key: KeyDataParents, data: {}) => void
    dataOnParents: DataOnParents
    masterAccount: string
}

const Step2 = ({ close, back, next, handleSaveDataOnParents, dataOnParents, masterAccount }: PropsStep) => {
    const theme = useTheme()
    const { t } = useTranslation()
    const { Step1, dataVerify }: { Step1: any, dataVerify: VerifyData } = dataOnParents

    const { cosInfo } = useCosInfo()
    const { refaccount } = cosInfo

    const rows = Step1?.rows ?? []
    const listSelected: any[] = Step1?.listSelected ?? []
    const cellInputValue = Step1?.cellInputValue ?? {}

    const refAuth = useRef<AuthComponentRef>(null)
    const [code, setCode] = useState<string>('')

    const handleNext = async () => {
        if (validateCode(code) === false) {
            ToastUtil.error(t('copytrade.common.noEmpty'))
            return
        }

        if (refAuth.current) {
            refAuth.current.processAuth()
        }
    }

    const processSellPortfoliosStuck = async (dataVerify: any) => {
        const dataFilter = rows.filter((item: any) => listSelected.includes(item.symbol))
        const dataForPost: {
            // account: string
            masterAccount: string
            symbol: string
            quantity: number
            price: number
        }[] = dataFilter.map((item: any) => {
            return {
                // account: refaccount ?? null,
                masterAccount: masterAccount ?? null,
                symbol: item.symbol ?? null,
                quantity: cellInputValue[item.symbol]?.qttyInput?.value ?? item.qtty,
                price: cellInputValue[item.symbol]?.priceInput?.value ?? item.price,
            }
        })

        await submitSellPortfoliosStuck({ accountId: refaccount, dataForPost, dataVerify }).then((rs) => {
            setStateLoadingAction(false)
            const { isSuccess, data } = rs
            if (isSuccess === true) {
                close()
                const { errorMsgList, successMsgList } = data as ListResponse
                if (successMsgList.length !== 0) {
                    ToastUtil.successRaw(t("msgApi.notificationSuccess.submitSellPortfoliosStuck"), successMsgList)
                }

                if (errorMsgList.length !== 0) {
                    ToastUtil.errorRaw(t("msgApi.error.submitSellPortfoliosStuck"), errorMsgList, 15000)
                }
            }
        })
    }

    const handleBack = () => {
        back()
    }

    const dataFilter = rows.filter((item: any) => listSelected.includes(item.symbol))

    const isValidCode = useValidateCode(code)

    console.log('ha_check_dataFilter', { dataFilter, listSelected, rows })

    return (
        <Box>
            <Stack
                direction={"column"}
                spacing={2}
            >
                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    borderRadius={1}
                    bgcolor={theme.palette.background.badge}
                >
                    <Table sx={{ minWidth: 350 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ padding: "12px 16px" }}>{t("copytrade.common.symbol")}</TableCell>
                                <TableCell sx={{ padding: "12px 16px" }} align="right">{t("copytrade.sellStuckStocks.orderQtty")}</TableCell>
                                <TableCell sx={{ padding: "12px 16px" }} align="right">{t("copytrade.sellStuckStocks.orderPrice")}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {dataFilter.map((row: any, index: number) => (
                                <TableRow
                                    key={index}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell sx={{ padding: "12px 16px", borderBottom: 'unset' }} component="th" scope="row">
                                        {row.symbol}
                                    </TableCell>
                                    <TableCell sx={{ padding: "12px 16px", borderBottom: 'unset' }} align="right"><ViewNumberFormat displayType='text' value={cellInputValue[row.symbol]?.qttyInput?.value ?? row.qtty} />  </TableCell>
                                    <TableCell sx={{ padding: "12px 16px", borderBottom: 'unset' }} align="right"><ViewNumberFormat displayType='text' value={cellInputValue[row.symbol]?.priceInput?.value ?? row.price} /> </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Stack>

                <Box>
                    {dataVerify?.transactionId && <TransAuth
                        ref={refAuth}
                        verified={dataVerify?.verified ?? false}
                        listAuthType={dataVerify?.authtypes ?? []}
                        defaultAuthType={dataVerify?.authtype}
                        transactionId={dataVerify?.transactionId}
                        tokenId={dataVerify?.tokenid}
                        setLoadStatus={setStateLoadingAction}
                        doProcessData={{}}
                        twoFactorAuthFunc={processSellPortfoliosStuck}
                        noButton={true}
                        onAuthCodeChange={(e: string) => setCode(e)}
                    />}
                </Box>

                <Stack
                    direction={"row"}
                    spacing={2}
                    justifyContent={"center"}
                >
                    <ButtonElement customType="Secondary" className={cx("btn-register")} variant="contained"
                        onClick={() => handleBack()} >{t("copytrade.common.back")}</ButtonElement>
                    <ButtonElement customType="Primary" className={cx("btn-register")} variant="contained"
                        disabled={!isValidCode}
                        onClick={
                            () => handleNext()
                        } >{t("copytrade.common.confirm")}</ButtonElement>
                </Stack>
            </Stack>
        </Box>
    )
}

export default Step2